<template>
  <div v-if="isElectron && os === 'darwin'" v-show="winStatus !== 'max'" style="-webkit-app-region: drag; width: 65px" />
</template>

<script>
export default {
  name: "macLeftSpace",
  data() {
    return {
      os: this.env.os,
      isElectron: this.env.isElectron,
      winStatus: "normal",
    }
  },
  mounted() {
    let self = this
    this.utils.electron.winStatusUpdateHandlerAdd((status) => { self.winStatus = status })
  }
}
</script>

<style scoped>

</style>
